const GradientIcon = ({ IconComponent, ...props }) => (
  <>
    <svg width="0" height="0" style={{ position: "absolute" }}>
      <linearGradient id="red-gradient" x1="0" y1="0" x2="0" y2="100%">
        <stop offset="0%" stopColor="#280609" />
        <stop offset="58%" stopColor="#8e161f" />
      </linearGradient>
    </svg>
    <IconComponent
      {...props}
      sx={{ ...props.sx, fill: "url(#red-gradient)" }}
    />
  </>
);

export default GradientIcon;
